module.exports = __webpack_public_path__ + "static/media/quick-blackjack.1b718c20.png";